export default "__VITE_ASSET__CsDtCVaA__"